import { Helmet } from "react-helmet";
import { useStore } from "../../context/StoreContext";
import ComingSoon from "../../pages/comingSoon";
import Footer from "../Footer";
import { isInIframe } from "../../utilities/helper";
import IframeFooter from "../Footer/IframeFooter";
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const AppWrapper = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { storeDetails, pageDetails, loading, error, shouldRedirectToComingSoon } = useStore();
    
    useEffect(() => {
        if (shouldRedirectToComingSoon && location.pathname !== '/store-not-available') {
            navigate('/store-not-available', { replace: true });
        } else if (!shouldRedirectToComingSoon && location.pathname === '/store-not-available') {
            navigate('/', { replace: true });
        }
    }, [shouldRedirectToComingSoon, location.pathname, navigate]);
    
    // Skip skeleton loading for store-not-available route
    if (location.pathname === '/store-not-available') {
        return (
            <div className='min-h-screen'>
                <div className="max-w-[1440px] mx-auto custom-background">
                    <main className="flex-grow">
                        {children}
                    </main>
                </div>
            </div>
        );
    }
    
    if (storeDetails?.status && storeDetails?.status !== 'INITIAL_PROCESS_COMPLETED_AND_LAUNCHED') {
        return <ComingSoon />
    }
    return (
        <div className={isInIframe() ? '' : 'min-h-screen'}>
        <div className="max-w-[1440px] mx-auto custom-background">
            <Helmet>
                {/* <link rel="icon" href={storeDetails?.store_logo || "/favicon.icon"} /> */}
                {/* <link rel="apple-touch-icon" href={storeDetails?.store_logo || "/favicon.png"} /> */}
                <meta name="description" content={storeDetails?.hero_text || storeDetails?.store_name} />
                <title>{storeDetails?.store_name}</title>
            </Helmet>
            <main className="flex-grow">
                {children}
            </main>
            {isInIframe() ? <IframeFooter /> : <Footer />}
        </div>
        </div>
    );
};

export default AppWrapper;
